import React from 'react';
import { labelForChain } from './agentChainLabels';
import './AgentChainChips.scss';

interface AgentChainChipsProps {
  chains: string[];
  className?: string;
  size?: 'sm' | 'md';
}

/**
 * Read-only strip of an agent's declared chains. Used on the agent
 * profile hero + My Agents cards so viewers can see at a glance
 * which blockchains the agent operates on.
 *
 * Interactive multi-select lives in AgentChainPicker.
 */
const AgentChainChips: React.FC<AgentChainChipsProps> = ({
  chains,
  className = '',
  size = 'md',
}) => {
  if (!chains || chains.length === 0) return null;
  return (
    <ul className={`agent-chain-chips agent-chain-chips--${size} ${className}`.trim()}>
      {chains.map((c) => (
        <li key={c} className={`agent-chain-chip agent-chain-chip--${c}`}>
          {labelForChain(c)}
        </li>
      ))}
    </ul>
  );
};

export default AgentChainChips;
